// components/Elements/Tooltip.jsx
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { forwardRef } from 'react';

export const ToolTip = forwardRef(function Tooltip({ content, children }, ref) {
  return (
    <TooltipPrimitive.Provider>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild ref={ref}>
          {children}
        </TooltipPrimitive.Trigger>

        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side="top"
            className="z-50 text-xs px-2 py-1 rounded-md bg-black/70 text-white shadow-md backdrop-blur-md border border-white/10"
          >
            {content}
            <TooltipPrimitive.Arrow className="fill-black/70" />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
});
